// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2wY7F","loaderOuter":"PageOverlayLoader_loaderOuter__zNtAY"};